import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './search-results-item.component.scss';
var SearchResultsItem = /** @class */ (function (_super) {
    tslib_1.__extends(SearchResultsItem, _super);
    function SearchResultsItem(element) {
        return _super.call(this, element) || this;
    }
    SearchResultsItem.prototype.init = function () { };
    SearchResultsItem.prototype.bindEvents = function () { };
    return SearchResultsItem;
}(Base));
export { SearchResultsItem };



//////////////////
// WEBPACK FOOTER
// ./components/search-results-item/search-results-item.component.ts
// module id = 490
// module chunks = 0